// REFORM Pulse — shared constants (options, copy, testIds, imagery)

export const NAV_LINKS = [
    { label: "Home", to: "/", testId: "nav-link-home" },
    { label: "Services", to: "/services", testId: "nav-link-services" },
    { label: "Work", to: "/work", testId: "nav-link-work" },
    { label: "About", to: "/about", testId: "nav-link-about" },
    { label: "Contact", to: "/contact", testId: "nav-link-contact" },
];

export const EVENT_TYPE_OPTIONS = [
    { value: "Brand Launch", label: "Brand Launch" },
    { value: "Product Launch", label: "Product Launch" },
    { value: "Pop-Up", label: "Pop-Up" },
    { value: "Media / KOL Event", label: "Media / KOL Event" },
    { value: "PR Event", label: "PR Event" },
    { value: "Corporate Event", label: "Corporate Event" },
    { value: "Community Activation", label: "Community Activation" },
    { value: "Not Sure Yet", label: "Not Sure Yet" },
];

export const BUDGET_OPTIONS = [
    { value: "Below RM50,000", label: "Below RM50,000" },
    { value: "RM50,000 - RM100,000", label: "RM50,000 - RM100,000" },
    { value: "RM100,000 - RM250,000", label: "RM100,000 - RM250,000" },
    { value: "RM250,000 - RM500,000", label: "RM250,000 - RM500,000" },
    { value: "RM500,000+", label: "RM500,000+" },
    { value: "Not confirmed yet", label: "Not confirmed yet" },
];

export const GOAL_OPTIONS = [
    { value: "Awareness", label: "Awareness" },
    { value: "PR / Media Coverage", label: "PR / Media Coverage" },
    { value: "Creator Content", label: "Creator Content" },
    { value: "Product Trial", label: "Product Trial" },
    { value: "Sales / Conversion", label: "Sales / Conversion" },
    { value: "Community Building", label: "Community Building" },
    { value: "Internal Engagement", label: "Internal Engagement" },
    { value: "Other", label: "Other" },
];

export const TICKER_WORDS = [
    "BRAND LAUNCHES",
    "POP-UPS",
    "MEDIA NIGHTS",
    "CREATOR EVENTS",
    "CULTURAL TAKEOVERS",
    "PRODUCT EXPERIENCES",
    "PR MOMENTS",
    "LIVE CONTENT",
];

export const EVENT_TYPES = [
    {
        key: "brand-launches",
        title: "Brand Launches",
        hook: "First impressions designed for press, participation and social momentum.",
        bullets: [
            "Launch strategy",
            "Creative concept",
            "Audience journey",
        ],
        tag: "01 / Launch",
    },
    {
        key: "popups-takeovers",
        title: "Pop-Ups & Cultural Takeovers",
        hook: "Unexpected spaces transformed into immersive brand worlds across Malaysia and Southeast Asia.",
        bullets: [
            "Venue and cultural insight",
            "Experience design",
            "Installation and production",
        ],
        tag: "02 / Takeover",
    },
    {
        key: "creator-media",
        title: "Creator & Media Experiences",
        hook: "Invite-only moments built for creators, tastemakers, media and earned conversation.",
        bullets: [
            "Guest curation",
            "Content programming",
            "Creator activation",
        ],
        tag: "03 / Creators",
    },
    {
        key: "pr-lifestyle",
        title: "PR & Lifestyle Events",
        hook: "Story-worthy experiences designed with media relevance from the start.",
        bullets: [
            "Narrative development",
            "Media-ready moments",
            "Run-of-show production",
        ],
        tag: "04 / PR",
    },
    {
        key: "product-discovery",
        title: "Product Discovery",
        hook: "Interactive experiences that turn product trial into participation and content.",
        bullets: [
            "Sampling journeys",
            "Live demonstrations",
            "Conversion-focused flow",
        ],
        tag: "05 / Product",
    },
    {
        key: "social-first",
        title: "Social-First Event Production",
        hook: "Every set-piece considered as a photograph, video and shareable moment.",
        bullets: [
            "Camera-ready environments",
            "Capture planning",
            "Social amplification",
        ],
        tag: "06 / Social",
    },
    {
        key: "corporate-community",
        title: "Corporate & Community Experiences",
        hook: "Internal and stakeholder events with the creativity and care of a consumer experience.",
        bullets: [
            "Culture events",
            "Client experiences",
            "Community programming",
        ],
        tag: "07 / Community",
    },
];

export const PULSE_METHOD = [
    {
        step: "01",
        title: "Decode the Objective",
        body: "Clarify the business goal, audience, product story and desired outcome.",
    },
    {
        step: "02",
        title: "Find the Cultural Hook",
        body: "Identify the behaviour, tension, reference or context that makes the experience relevant.",
    },
    {
        step: "03",
        title: "Build the Experience & Audience",
        body: "Shape the concept, journey, visual world, programming and the right mix of creators, media, partners and communities.",
    },
    {
        step: "04",
        title: "Execute & Amplify",
        body: "Produce the experience and extend its value through content, PR and social.",
    },
];

/** New consolidated Why Pulse differentiators (exactly three, no more).
 *  Replaces the previous six DIFFERENTIATORS on the homepage. The full
 *  six-item DIFFERENTIATORS constant below is retained for possible use
 *  on the About page. */
export const WHY_PULSE_DIFFERENTIATORS = [
    {
        step: "01",
        title: "Strategy-Led",
        body: "We start with the brand outcome\u2014not the venue checklist.",
    },
    {
        step: "02",
        title: "Culture-Built",
        body: "Audience behaviour, timing and context shape the idea.",
    },
    {
        step: "03",
        title: "Designed to Travel",
        body: "Every important moment is planned for participation, content and earned attention.",
    },
];

/** Compact REFORM Group capability pills for the ecosystem strip that
 *  sits beneath the Why Pulse differentiators. */
export const REFORM_ECOSYSTEM_PILLS = [
    "Strategy",
    "Creators",
    "Content",
    "Production",
    "PR",
    "Social",
];

export const DIFFERENTIATORS = [
    { title: "Strategy First", body: "We begin with the campaign outcome—not the venue checklist." },
    { title: "Culturally Aware", body: "Local behaviour, timing and taste shape the idea." },
    { title: "Designed to Travel", body: "Every important moment is considered for photography, video and sharing." },
    { title: "Creator & Media Fluent", body: "We understand how creators, audiences and editors experience a brand moment." },
    { title: "Full REFORM Ecosystem", body: "Strategy, creators, content, production, PR and amplification can work as one team." },
    { title: "Comfortable with Bold", body: "When a brief feels too safe, we know where to push it." },
];

export const CONCEPT_TERRITORIES = [
    {
        key: "kopitiam-after-dark",
        title: "Kopitiam After Dark",
        blurb: "A familiar Malaysian space transformed into a premium invite-only brand party with creators, DJs, product discovery and local cultural details.",
        unlocks: "Cultural resonance + PR",
        image: "https://images.unsplash.com/photo-1514933651103-005eec06c04b?auto=format&fit=crop&w=1400&q=80",
    },
    {
        key: "product-playground",
        title: "The Product Playground",
        blurb: "A pop-up experience where every corner is designed for discovery, trial, content and conversion.",
        unlocks: "Trial + social content",
        image: "https://images.unsplash.com/photo-1531058020387-3be344556be6?auto=format&fit=crop&w=1400&q=80",
    },
    {
        key: "creator-house",
        title: "The Creator House",
        blurb: "A content-first event designed for creators to experience, shoot and amplify a brand story in real time.",
        unlocks: "Creator content at scale",
        image: "https://images.unsplash.com/photo-1519671482749-fd09be7ccebf?auto=format&fit=crop&w=1400&q=80",
    },
    {
        key: "launch-nobody-expected",
        title: "The Launch Nobody Expected",
        blurb: "A campaign launch hosted in an unconventional location, designed to disrupt the usual hotel ballroom format.",
        unlocks: "Press-worthy first impression",
        image: "https://images.unsplash.com/photo-1492684223066-81342ee5ff30?auto=format&fit=crop&w=1400&q=80",
    },
    {
        key: "tastemaker-table",
        title: "The Tastemaker Table",
        blurb: "A premium dinner or intimate gathering built for media, celebrities, high-value clients and influential communities.",
        unlocks: "High-value word of mouth",
        image: "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?auto=format&fit=crop&w=1400&q=80",
    },
    {
        key: "social-first-roadshow",
        title: "The Social-First Roadshow",
        blurb: "A scalable activation format that can travel across malls, campuses, offices or lifestyle locations.",
        unlocks: "Scale + geographic reach",
        image: "https://images.unsplash.com/photo-1517457373958-b7bdd4587205?auto=format&fit=crop&w=1400&q=80",
    },
];

// Selected Work — real REFORM Pulse case studies
export const SELECTED_WORK = [
    {
        key: "atlas-brand-experience",
        slug: "atlas-brand-experience",
        number: "01",
        client: "BANK MUAMALAT",
        title: "ATLAS BRAND EXPERIENCE",
        categories: ["BRAND EXPERIENCE", "PUBLIC ACTIVATION", "PRODUCT DISCOVERY"],
        summary:
            "An immersive public activation for Atlas by Bank Muamalat, designed to introduce the brand through a bold physical environment, interactive discovery touchpoints and an attention-commanding centrepiece.",
        supporting_copy:
            "The experience transformed a high-traffic mall space into a branded journey where audiences could explore Atlas, interact with its features and encounter the brand beyond traditional advertising.",
        primary_image:
            "https://customer-assets.emergentagent.com/job_pulse-activations/artifacts/c2csqei3_DSC04624.webp",
        primary_image_alt:
            "Atlas by Bank Muamalat branded activation environment at IOI City Mall",
        primary_image_position: "center 68%",
        primary_image_aspect: "16 / 10",
        secondary_image:
            "https://customer-assets.emergentagent.com/job_pulse-activations/artifacts/o7rfuvjb_DSC04588.webp",
        secondary_image_alt: "Illuminated Atlas brand installation",
        secondary_image_position: "center 55%",
        layout: "image-left",
        challenge:
            "Create a physical brand experience that helped audiences discover Atlas in a way that felt visible, interactive and accessible within a public retail environment.",
        approach:
            "REFORM developed a branded walkthrough experience anchored by a bold visual installation and digital discovery touchpoints.",
        delivered: [
            "Branded activation environment",
            "Physical centrepiece installation",
            "Digital product discovery screens",
            "Public engagement space",
            "On-ground event production",
        ],
        revealed: true,
    },
    {
        key: "reform-coffee-rave",
        slug: "reform-coffee-rave",
        number: "02",
        client: "REFORM",
        title: "REFORM COFFEE RAVE",
        categories: ["CULTURAL ACTIVATION", "COMMUNITY EXPERIENCE", "MUSIC & CONTENT"],
        summary:
            "A coffee-led daytime rave created as a live expression of REFORM's culture—bringing together music, community and content in a format designed to feel unexpected, social and highly shareable.",
        supporting_copy:
            "The experience reframed an everyday ritual as a cultural moment, combining atmosphere, programming and audience participation into one distinct live brand world.",
        primary_image: "/media/coffee-rave-poster.webp",
        primary_image_alt:
            "REFORM Coffee Rave title card — a daytime rave moment in warm, cinematic lighting",
        primary_image_position: "center",
        primary_image_aspect: "16 / 10",
        secondary_image: "/media/coffee-rave-poster.webp",
        secondary_image_alt:
            "REFORM Coffee Rave — poster frame",
        secondary_image_position: "center",
        layout: "image-right",
        challenge:
            "Turn REFORM's own culture into a live experience—one that felt unexpected, social and highly shareable without leaning on a conventional event format.",
        approach:
            "REFORM designed a coffee-led daytime rave that reframed an everyday ritual as a cultural moment, combining music, programming and community participation.",
        delivered: [
            "Cultural experience concept",
            "Live programming and atmosphere",
            "Community activation",
            "On-ground production",
            "Content capture and film",
        ],
        video: {
            poster: "/media/coffee-rave-poster.webp",
            posterAlt:
                "REFORM Coffee Rave — poster frame from the film",
            sources: [
                { src: "/media/coffee-rave-1080.webm", type: "video/webm" },
                { src: "/media/coffee-rave-1080.mp4", type: "video/mp4" },
            ],
        },
        revealed: true,
    },
    {
        key: "indomie-campus-roadshow",
        slug: "indomie-campus-roadshow",
        number: "03",
        client: "INDOMIE",
        title: "INDOMIE CAMPUS ROADSHOW",
        categories: ["CAMPUS ACTIVATION", "PRODUCT SAMPLING", "YOUTH ENGAGEMENT"],
        summary:
            "A youth-focused campus activation designed to bring Indomie directly into student culture through product sampling, participation, social content and a multi-campus roadshow experience.",
        supporting_copy:
            "The campaign created an energetic branded environment where students could discover the product, engage with the activation and generate organic social moments across Klang Valley campuses.",
        primary_image:
            "https://customer-assets.emergentagent.com/job_pulse-activations/artifacts/12tba78g_20250923_135333.webp",
        primary_image_alt:
            "Indomie campus roadshow participant holding branded product displays",
        primary_image_position: "center 38%",
        primary_image_aspect: "4 / 5",
        secondary_image:
            "https://customer-assets.emergentagent.com/job_pulse-activations/artifacts/eg3b741k_20250924_111401.webp",
        secondary_image_alt:
            "Indomie Campus Roadshow schedule across Klang Valley universities",
        secondary_image_position: "center 32%",
        layout: "image-left",
        challenge:
            "Bring the Indomie product experience directly to young consumers in a setting where participation, sampling and social engagement could happen naturally.",
        approach:
            "REFORM created a campus roadshow format combining product discovery, branded participation, sampling and social-content moments.",
        delivered: [
            "Multi-campus roadshow",
            "Product sampling experience",
            "Branded activation setup",
            "Audience engagement activities",
            "Social-content moments",
            "On-ground event execution",
        ],
        revealed: true,
    },
];

export function findSelectedWork(slug) {
    return SELECTED_WORK.find((c) => c.slug === slug && c.revealed) || null;
}

export const ECOSYSTEM_PILLARS = [
    { label: "Strategy", icon: "Compass" },
    { label: "Creators", icon: "Users" },
    { label: "Content", icon: "Clapperboard" },
    { label: "Production", icon: "Wrench" },
    { label: "Events", icon: "Sparkles" },
    { label: "PR", icon: "Megaphone" },
    { label: "Social Amplification", icon: "Radio" },
];

export const HERO_IMAGES = [
    "https://images.unsplash.com/photo-1524368535928-5b5e00ddc76b?auto=format&fit=crop&w=2000&q=80",
    "https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?auto=format&fit=crop&w=2000&q=80",
];

export const CONTACT_INFO = {
    email: "hello@reform-pulse.com",
    whatsapp: "+60 17-961 8351",
    whatsappNumber: "60179618351",
    instagram: "@reform_digital",
    instagramUrl: "https://instagram.com/reform_digital",
    linkedin: "REFORM",
    linkedinUrl: "https://www.linkedin.com/company/digitalreform/",
    city: "Kuala Lumpur, Malaysia",
};

export const CALENDLY_URL = (
    typeof process !== "undefined" && process.env && process.env.REACT_APP_CALENDLY_URL
) ? process.env.REACT_APP_CALENDLY_URL.trim() : "";

export const WHATSAPP_NUMBER = (
    typeof process !== "undefined" && process.env && process.env.REACT_APP_WHATSAPP_NUMBER
) ? process.env.REACT_APP_WHATSAPP_NUMBER.trim() : "60179618351";

export function strategyCallHref() {
    return CALENDLY_URL || "/contact";
}

export function strategyCallIsExternal() {
    return Boolean(CALENDLY_URL);
}

export function whatsappHref(prefilledMessage = "") {
    const num = (WHATSAPP_NUMBER || "").replace(/[^0-9]/g, "");
    if (!num) return "#";
    const text = prefilledMessage ? `?text=${encodeURIComponent(prefilledMessage)}` : "";
    return `https://wa.me/${num}${text}`;
}

export const PULSE_TESTIDS = {
    nav: {
        header: "site-header",
        primaryCta: "nav-start-pulse-brief-button",
        mobileMenu: "nav-mobile-menu-button",
    },
    hero: {
        section: "home-hero-section",
        primaryCta: "hero-primary-cta-button",
        secondaryCta: "hero-secondary-cta-button",
    },
    form: {
        section: "home-lead-form-section",
        form: "pulse-brief-form",
        submit: "pulse-brief-submit-button",
        name: "pulse-brief-name-input",
        company: "pulse-brief-company-input",
        email: "pulse-brief-email-input",
        phone: "pulse-brief-phone-input",
        brand: "pulse-brief-brand-input",
        eventType: "pulse-brief-event-type-select",
        eventDate: "pulse-brief-event-date-input",
        budget: "pulse-brief-budget-select",
        goal: "pulse-brief-goal-select",
        message: "pulse-brief-message-textarea",
        honeypot: "pulse-brief-honeypot-input",
        success: "pulse-brief-success-message",
    },
    footer: {
        section: "site-footer",
    },
    admin: {
        page: "admin-page",
        usernameInput: "admin-login-username-input",
        passwordInput: "admin-login-password-input",
        submit: "admin-login-submit-button",
        table: "admin-leads-table",
        row: "admin-leads-row",
        logout: "admin-logout-button",
    },
};
